import axios from 'axios';

const AxiosFileClient = axios.create({});

AxiosFileClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error),
);

export { AxiosFileClient };
